import EmptyState from "./EmptyState";
import ReadOnlyMetadataItem from "./MetadataItemRow/ReadOnlyMetadataItemRow";
import { MetadataItem } from "./types";

const ReadOnlyContent = ({
  metadataArray,
}: {
  metadataArray: MetadataItem[];
}) => (
  <>
    {metadataArray.length > 0 ? (
      <div className="w-full break-words font-mono text-xs text-gray-600">
        {metadataArray.map((item) => (
          <ReadOnlyMetadataItem
            key={item.id}
            keyName={item.key}
            value={item.value}
          />
        ))}
      </div>
    ) : (
      <EmptyState />
    )}
  </>
);

export default ReadOnlyContent;
